import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import datastore from '@datastore';
import FormControlSelectRow from './form_control_select_row';

const CountrySelect = props => (
  <FormControlSelectRow
    {...props}
    options={_.map(props.typeCountries, country => ({
      value: country.code,
      label: country.name,
    }))}
  />
);

CountrySelect.propTypes = {
  typeCountries: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
};

const mapStateToProps = state => ({
  typeCountries: datastore.selectors.getTypes(state, 'countries'),
});

export default connect(mapStateToProps)(CountrySelect);
